module.exports = __webpack_public_path__ + "static/img/mt_download_use_case_2.73003c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_download_use_case_2.png
// module id = 350
// module chunks = 2